import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetRegistrations, GetRegistrationsResponse, RegistrationSort, RegistrationStatus } from '../api/dtos';
import useGet from './api/useGet';

const getData = (response?: SWRResponse<GetRegistrationsResponse, GetRegistrationsResponse>) => response?.data?.registrations;
const getError = (response?: SWRResponse<GetRegistrationsResponse, GetRegistrationsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetRegistrationsResponse, GetRegistrationsResponse>) => ({
    registrations: response?.data?.registrations,
    count: response?.data?.count
});

export const useRegistrations = (
    page?: number, 
    rows?: number, 
    sort?: RegistrationSort, 
    descending?: boolean,
    includeExpired?: boolean,
    includeSessions?: boolean,
    search?: string,
    registrationStatus?: RegistrationStatus, 
    configuration?: SWRConfiguration | undefined,
    enabled: boolean = true
) => {
    const request = useMemo(() => {
        if (!enabled) return undefined;
        return () => {
            return new GetRegistrations({
                page, 
                rows, 
                sort, 
                descending,
                includeExpired,
                includeSessions,
                search,
                registrationStatus
            });
        }
    }, [
        page, 
        rows, 
        sort, 
        descending,
        includeExpired,
        includeSessions,
        search,
        registrationStatus,
        enabled
    ]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useRegistrations;